import UsernameField from '../../molecules/UsernameField'
import PasswordField from '../../molecules/PasswordField'
import ErrorAlert from '../../molecules/ErrorAlert'

import { useIntl } from 'react-intl'; 

import { Form, Button } from 'react-bootstrap';

const LoginForm = ({
    logo,
    loading,
    errorData,
    setErrorData,
    handleSubmit,
    onUserChange,
    onPasswordChange
}) => {
  const intl = useIntl();

  return (
      <Form className="shadow p-4 bg-white rounded otherstuff" onSubmit={handleSubmit}>
        <img
          className="rounded mx-auto d-block mb-2"
          src={logo}
          alt="logo"
        />
        <div className="h4 mb-2 text-center">{intl.messages.loginForm.signin}</div>        
        <ErrorAlert errorData={errorData} setErrorData={setErrorData}/>
        <UsernameField labelText={intl.messages.loginForm.username} 
          placeholder={intl.messages.loginForm.typeUsername}
          onChange={onUserChange}
          />
        <PasswordField labelText={intl.messages.loginForm.password} 
          placeholder={intl.messages.loginForm.typePassword}
          onChange={onPasswordChange}
          />
        {!loading ? (
          <Button className="w-100" variant="giant-primary" type="submit">
            {intl.messages.loginForm.signin}
          </Button>
        ) : (
          <Button className="w-100" variant="giant-primary" type="submit" disabled>
            {intl.messages.loginForm.signingin}
          </Button>
        )}
      </Form>
  );
};

export default LoginForm;
